module.exports = __webpack_public_path__ + "static/media/vacuumTruck.e3c5551c.svg";